import { SnackbarOptions } from 'gd-design-library';
import React, { Dispatch, SetStateAction } from 'react';

export interface SnackbarParams {
  open?: boolean,
  message: string,
  onClose: () => void,
  severity?: SnackbarOptions['variant']
}

export const defaultSnackbarParams: SnackbarParams = {
  open: false,
  onClose: () => null,
  message: ''
};

export const SnackbarContext = React.createContext<{
  snackbarParams: SnackbarParams,
  setSnackbarParams: Dispatch<SetStateAction<SnackbarParams>>
}>({
  snackbarParams: defaultSnackbarParams,
  setSnackbarParams: () => null
});
